import { render, staticRenderFns } from "./ProposedChangesShow.vue?vue&type=template&id=6b3fe550&scoped=true"
import script from "./ProposedChangesShow.vue?vue&type=script&lang=js"
export * from "./ProposedChangesShow.vue?vue&type=script&lang=js"
import style0 from "./ProposedChangesShow.vue?vue&type=style&index=0&id=6b3fe550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3fe550",
  null
  
)

export default component.exports